var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8MaltaCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M24,44c11.046,0,20-8.954,20-20c0-11.046-8.954-20-20-20V44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M24,44V4C12.954,4,4,12.954,4,24C4,35.046,12.954,44,24,44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M19.766,13.058c0,0-2.482-0.016-2.473-0.007c0-0.575-0.238-0.893-0.859-0.896V9.726H13.93 c0,0-0.01,2.451-0.001,2.442c-0.579,0-0.898,0.239-0.898,0.868c0.183,0-2.434,0.022-2.434,0.022v2.504h2.44 c0.017,0.539,0.256,0.841,0.861,0.841c0-0.166,0.03,2.491,0.03,2.491h2.504v-2.511c0.536-0.012,0.837-0.244,0.853-0.821h2.479 V13.058z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c9082a",
    d: "M16.434,19.144h-2.503c-0.137,0-0.248-0.11-0.25-0.247c0,0-0.02-1.641-0.027-2.26 c-0.473-0.07-0.758-0.351-0.841-0.825h-2.214c-0.138,0-0.25-0.112-0.25-0.25v-2.504c0-0.138,0.11-0.249,0.248-0.25 c0,0,1.591-0.013,2.203-0.019c0.058-0.393,0.276-0.777,0.889-0.856c-0.016-0.356-0.013-1.005-0.008-2.208 c0.001-0.138,0.112-0.249,0.25-0.249h2.503c0.138,0,0.25,0.112,0.25,0.25v2.198c0.388,0.061,0.767,0.28,0.845,0.886 c0.357-0.015,1.013-0.01,2.239-0.002c0.137,0.001,0.248,0.112,0.248,0.25v2.504c0,0.138-0.112,0.25-0.25,0.25h-2.253 c-0.065,0.358-0.277,0.71-0.829,0.8v2.282C16.684,19.031,16.571,19.144,16.434,19.144z M14.178,18.644h2.006v-2.261 c0-0.136,0.108-0.247,0.244-0.25c0.434-0.01,0.599-0.166,0.609-0.578c0.004-0.136,0.114-0.243,0.25-0.243h2.229v-2.006 c-0.898-0.005-2.067-0.011-2.197-0.006c-0.021,0.002-0.047,0.002-0.071-0.003c-0.118-0.022-0.204-0.126-0.204-0.246 c0-0.475-0.16-0.644-0.611-0.646c-0.137-0.001-0.248-0.112-0.248-0.25V9.976H14.18c-0.003,0.886-0.006,2.034-0.001,2.166 c0.002,0.022,0.001,0.046-0.003,0.068c-0.021,0.12-0.124,0.208-0.246,0.208c-0.456,0-0.631,0.147-0.646,0.558 c0.005,0.019,0.008,0.039,0.008,0.06c0.001,0.114,0.001,0.176-0.253,0.212l-0.001,0.039c-0.039,0-0.077-0.01-0.111-0.026 c-0.323,0.029-0.932,0.036-2.077,0.046v2.006h2.19c0.135,0,0.246,0.107,0.25,0.242c0.013,0.424,0.159,0.585,0.555,0.599 c0.021-0.005,0.041-0.008,0.071-0.007c0.103,0,0.16,0.012,0.195,0.254l0.039,0.001c0,0.039-0.01,0.076-0.026,0.11 C14.154,16.839,14.164,17.462,14.178,18.644z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M13.93,12.168c-0.579,0-0.898,0.239-0.898,0.868c0.349,0,0.898,0,0.898,0 S13.915,12.183,13.93,12.168z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M13.93,13.086h-0.897c-0.027,0-0.05-0.022-0.05-0.05c0-0.618,0.31-0.918,0.947-0.918 c0.02,0,0.038,0.012,0.046,0.03c0.005,0.011,0.005,0.023,0.002,0.035c-0.008,0.061-0.003,0.552,0.002,0.852 c0,0.014-0.005,0.026-0.014,0.036C13.956,13.081,13.943,13.086,13.93,13.086z M13.083,12.986h0.796 c-0.008-0.469-0.008-0.674-0.003-0.768C13.345,12.233,13.098,12.473,13.083,12.986z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.418,
    x2: 13.757,
    y1: 12.514,
    y2: 12.853,
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M13.757,12.903c-0.013,0-0.025-0.005-0.035-0.015l-0.339-0.34c-0.02-0.02-0.02-0.051,0-0.07 s0.051-0.02,0.07,0l0.339,0.34c0.02,0.02,0.02,0.051,0,0.07C13.782,12.898,13.77,12.903,13.757,12.903z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.301,
    x2: 13.581,
    y1: 12.747,
    y2: 12.986,
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M13.581,13.036c-0.012,0-0.023-0.004-0.032-0.012l-0.279-0.239 c-0.021-0.019-0.023-0.05-0.006-0.07c0.018-0.022,0.051-0.023,0.07-0.006l0.279,0.239c0.021,0.019,0.023,0.05,0.006,0.07 C13.609,13.03,13.595,13.036,13.581,13.036z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.66,
    x2: 13.93,
    y1: 12.378,
    y2: 12.647,
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M13.93,12.697c-0.013,0-0.025-0.005-0.035-0.015l-0.27-0.27c-0.02-0.02-0.02-0.051,0-0.07 s0.051-0.02,0.07,0l0.27,0.27c0.02,0.02,0.02,0.051,0,0.07C13.955,12.692,13.942,12.697,13.93,12.697z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M17.293,13.051c0-0.579-0.239-0.898-0.868-0.898c0,0.349,0,0.898,0,0.898 S17.278,13.036,17.293,13.051z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M17.293,13.101c-0.006,0-0.011-0.001-0.016-0.002c-0.061-0.008-0.551-0.002-0.852,0.002h-0.001 c-0.013,0-0.025-0.005-0.035-0.014c-0.01-0.01-0.015-0.022-0.015-0.036v-0.897c0-0.027,0.022-0.05,0.05-0.05 c0.626,0,0.918,0.301,0.918,0.947c0,0.021-0.012,0.038-0.03,0.046C17.306,13.1,17.3,13.101,17.293,13.101z M16.475,12.204V13 c0.468-0.009,0.676-0.008,0.768-0.003C17.228,12.466,16.988,12.219,16.475,12.204z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.947,
    x2: 16.608,
    y1: 12.539,
    y2: 12.878,
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M16.608,12.928c-0.013,0-0.025-0.005-0.035-0.015c-0.02-0.02-0.02-0.051,0-0.07l0.339-0.339 c0.02-0.02,0.051-0.02,0.07,0s0.02,0.051,0,0.07l-0.339,0.339C16.634,12.923,16.621,12.928,16.608,12.928z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 16.714,
    x2: 16.475,
    y1: 12.423,
    y2: 12.702,
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M16.475,12.752c-0.012,0-0.023-0.004-0.032-0.012c-0.021-0.019-0.023-0.05-0.006-0.07l0.24-0.279 c0.018-0.022,0.051-0.023,0.07-0.006c0.021,0.019,0.023,0.05,0.006,0.07l-0.24,0.279C16.503,12.746,16.488,12.752,16.475,12.752 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 17.083,
    x2: 16.814,
    y1: 12.782,
    y2: 13.051,
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M16.814,13.101c-0.013,0-0.025-0.005-0.035-0.015c-0.02-0.02-0.02-0.051,0-0.07l0.27-0.269 c0.02-0.02,0.051-0.02,0.07,0s0.02,0.051,0,0.07l-0.27,0.269C16.84,13.096,16.827,13.101,16.814,13.101z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M16.395,16.388c0.579,0,0.898-0.239,0.898-0.868c-0.349,0-0.898,0-0.898,0 S16.41,16.373,16.395,16.388z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M16.396,16.438c-0.021,0-0.038-0.012-0.046-0.03c-0.005-0.012-0.005-0.024-0.002-0.035 c0.008-0.061,0.003-0.551-0.002-0.851c0-0.014,0.005-0.026,0.014-0.036c0.01-0.01,0.022-0.015,0.036-0.015h0.897 c0.027,0,0.05,0.022,0.05,0.05C17.343,16.146,17.042,16.438,16.396,16.438z M16.446,15.57c0.008,0.468,0.008,0.673,0.003,0.767 c0.531-0.015,0.778-0.253,0.793-0.767H16.446z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.907,
    x2: 16.568,
    y1: 16.042,
    y2: 15.703,
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M16.907,16.092c-0.013,0-0.025-0.005-0.035-0.015l-0.339-0.339c-0.02-0.02-0.02-0.051,0-0.07 s0.051-0.02,0.07,0l0.339,0.339c0.02,0.02,0.02,0.051,0,0.07C16.933,16.087,16.92,16.092,16.907,16.092z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 17.024,
    x2: 16.744,
    y1: 15.809,
    y2: 15.57,
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M17.023,15.859c-0.012,0-0.023-0.004-0.032-0.012l-0.279-0.239 c-0.021-0.019-0.023-0.05-0.006-0.07c0.019-0.022,0.051-0.023,0.07-0.006l0.279,0.239c0.021,0.019,0.023,0.05,0.006,0.07 C17.052,15.854,17.037,15.859,17.023,15.859z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 16.665,
    x2: 16.395,
    y1: 16.178,
    y2: 15.909,
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M16.664,16.229c-0.013,0-0.025-0.005-0.035-0.015l-0.269-0.27c-0.02-0.02-0.02-0.051,0-0.07 s0.051-0.02,0.07,0l0.269,0.27c0.02,0.02,0.02,0.051,0,0.07C16.689,16.224,16.677,16.229,16.664,16.229z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M13.032,15.505c0,0.579,0.239,0.898,0.868,0.898c0-0.349,0-0.898,0-0.898 S13.047,15.52,13.032,15.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M13.899,16.453c-0.626,0-0.917-0.301-0.917-0.948c0-0.021,0.013-0.039,0.031-0.047 c0.012-0.004,0.023-0.004,0.035,0c0.062,0.008,0.552,0.002,0.85-0.003h0.001c0.013,0,0.025,0.005,0.035,0.014 c0.01,0.01,0.015,0.022,0.015,0.036v0.898C13.949,16.431,13.927,16.453,13.899,16.453z M13.083,15.559 c0.015,0.532,0.253,0.779,0.767,0.794v-0.797C13.384,15.564,13.178,15.565,13.083,15.559z M13.032,15.505L13.032,15.505 L13.032,15.505z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.378,
    x2: 13.717,
    y1: 16.017,
    y2: 15.678,
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M13.378,16.067c-0.013,0-0.025-0.005-0.035-0.015c-0.02-0.02-0.02-0.051,0-0.07l0.339-0.34 c0.02-0.02,0.051-0.02,0.07,0s0.02,0.051,0,0.07l-0.339,0.34C13.403,16.062,13.391,16.067,13.378,16.067z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 13.611,
    x2: 13.85,
    y1: 16.134,
    y2: 15.854,
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M13.61,16.184c-0.012,0-0.023-0.004-0.032-0.012c-0.021-0.019-0.023-0.05-0.006-0.07l0.239-0.279 c0.019-0.021,0.051-0.023,0.07-0.006c0.021,0.019,0.023,0.05,0.006,0.07l-0.239,0.279C13.639,16.178,13.624,16.184,13.61,16.184 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 13.241,
    x2: 13.511,
    y1: 15.774,
    y2: 15.505,
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M13.241,15.824c-0.013,0-0.025-0.005-0.035-0.015c-0.02-0.02-0.02-0.051,0-0.07l0.27-0.27 c0.02-0.02,0.051-0.02,0.07,0s0.02,0.051,0,0.07l-0.27,0.27C13.267,15.819,13.254,15.824,13.241,15.824z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 2.504,
    height: 9.168,
    x: 13.93,
    y: 9.726,
    fill: "#eceff1",
    transform: "rotate(-90 15.182 14.31)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M19.766,15.611h-9.167c-0.027,0-0.05-0.022-0.05-0.05v-2.504c0-0.027,0.022-0.05,0.05-0.05h9.167 c0.027,0,0.05,0.022,0.05,0.05v2.504C19.815,15.589,19.793,15.611,19.766,15.611z M10.648,15.512h9.067v-2.404h-9.067V15.512z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 2.504,
    height: 9.168,
    x: 13.93,
    y: 9.726,
    fill: "#eceff1",
    transform: "rotate(-180 15.182 14.31)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M16.435,18.943h-2.504c-0.027,0-0.05-0.022-0.05-0.05V9.726c0-0.027,0.022-0.05,0.05-0.05h2.504 c0.027,0,0.05,0.022,0.05,0.05v9.168C16.484,18.921,16.462,18.943,16.435,18.943z M13.98,18.844h2.404V9.775H13.98V18.844z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 15.182,
    cy: 14.31,
    r: 2.014,
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M15.183,16.373c-1.138,0-2.063-0.926-2.063-2.063s0.926-2.063,2.063-2.063 s2.063,0.926,2.063,2.063S16.32,16.373,15.183,16.373z M15.183,12.346c-1.083,0-1.964,0.881-1.964,1.964s0.881,1.964,1.964,1.964 s1.964-0.881,1.964-1.964S16.266,12.346,15.183,12.346z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 15.182,
    cy: 14.31,
    r: 1.431,
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M15.183,15.79c-0.817,0-1.481-0.664-1.481-1.48s0.664-1.48,1.481-1.48 c0.816,0,1.48,0.664,1.48,1.48S15.999,15.79,15.183,15.79z M15.183,12.929c-0.762,0-1.382,0.619-1.382,1.381 s0.62,1.381,1.382,1.381s1.381-0.619,1.381-1.381S15.944,12.929,15.183,12.929z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8MaltaCircular);
export default __webpack_public_path__ + "static/media/icons8-malta-circular.182e0b23c17d152366915dd6beb17e7e.svg";
export { ForwardRef as ReactComponent };